// removed by extract-text-webpack-plugin
module.exports = {"description":"app-pages-Employees-Pin-PinForm-__PinForm___DROPc","ask-staff-info":"app-pages-Employees-Pin-PinForm-__PinForm___1nnfj","form":"app-pages-Employees-Pin-PinForm-__PinForm___2CxxQ","switch-field":"app-pages-Employees-Pin-PinForm-__PinForm___j3PdU","separator":"app-pages-Employees-Pin-PinForm-__PinForm___reTdV","btn-save":"app-pages-Employees-Pin-PinForm-__PinForm___2gDBw"};


//////////////////
// WEBPACK FOOTER
// ./app/pages/Employees/Pin/PinForm/PinForm.css
// module id = 2323
// module chunks = 0